import { ParcelsTrackingList } from "domains/Parcel/components/Parcels/ParcelsList";
import React from 'react';
import { DateProvider } from "../components/HomeSides/Recap/context/dateContext";


export const ParcelsTracking = () => (
  <DateProvider>
    <ParcelsTrackingList />
  </DateProvider>
);
